import Cookies from 'js-cookie';
import { getUserLocationData } from '../datafetchers/productPage/getUserLocationData';

import { fireEvent } from './fireEvent';

export const fireUserLocationEvent = async (userType) => {
  if (!Cookies.get('region') || !Cookies.get('zone')) {
    const data = await getUserLocationData();
    if (data?.regionName) {
      fireEvent({
        category: 'user_region',
        parent: data.zone,
        support_variable: data.regionName,
      });
      Cookies.set('region', data.regionName);
      if (userType == 'B') {
        Cookies.set('zone', data.zone);
        Cookies.set('zone_term_id', data.termId);
      }
    }
  }
};
